import { Api } from 'api';

/**
 * 刪除 subject
 */
export const deleteQuestionnaireSubject = async (QuestionnaireId, SubjectId) => {
  const response = await Api.delete(`/admin/questionnaire/${QuestionnaireId}/subject/${SubjectId}`);
  return response;
};